import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-seguridad-listado-roles',
  templateUrl: './seguridad-listado-roles.component.html',
  styleUrls: ['./seguridad-listado-roles.component.scss']
})
export class SeguridadListadoRolesComponent implements OnInit {
  @Output() selecttab = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }

}
